import type { ChipTone } from '@cowoo/shared/ui-web';
import type { paths } from '@cowoo/api-client';
import { formatDate, formatMonth } from '@cowoo/shared';

/** How an invoice row reads (10-web-admin § 13). */

export type InvoiceItem =
  paths['/admin/invoices']['get']['responses']['200']['content']['application/json']['items'][number];

export const CHIPS = ['all', 'paid', 'open', 'uncollectible', 'void_by_credit_note'] as const;
export type InvoiceChip = (typeof CHIPS)[number];

export const STATUS_TONE: Record<string, ChipTone> = {
  paid: 'success',
  open: 'warn',
  uncollectible: 'danger',
  void_by_credit_note: 'neutral',
};

/**
 * "Leistungszeitraum": a whole month reads as the month, anything else as its
 * two dates, and a one-off line has only one.
 */
export function periodLabel(invoice: Pick<InvoiceItem, 'periodFrom' | 'periodTo' | 'issuedOn'>): string {
  const { periodFrom, periodTo } = invoice;
  if (!periodFrom) return formatDate(invoice.issuedOn);
  if (!periodTo || periodFrom === periodTo) return formatDate(periodFrom);

  const from = new Date(`${periodFrom}T12:00:00Z`);
  const to = new Date(`${periodTo}T12:00:00Z`);
  const wholeMonth =
    from.getUTCDate() === 1 &&
    from.getUTCMonth() === to.getUTCMonth() &&
    to.getUTCDate() === new Date(Date.UTC(to.getUTCFullYear(), to.getUTCMonth() + 1, 0)).getUTCDate();

  return wholeMonth ? formatMonth(periodFrom) : `${formatDate(periodFrom)} – ${formatDate(periodTo)}`;
}
